import { Navigate } from "react-router";
import * as ROUTES from "../../../../constants/routes";
import { ReactNode } from "react";
import { useCheckout } from "./CheckoutProvider.shared";

export const EmptySupplierBoundary = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { supplier } = useCheckout();

  if (!supplier) {
    return <Navigate to={ROUTES.SUPPLIERS} />;
  }

  return children;
};
